import React from "react";

import { type FlowItemScorm } from "../../../../features/Library/Flows/Designer/types";

import TopContent from "../BaseCard/TopContent";
import BottomContent from "../BaseCard/BottomContent";

export interface ScormCardOwnProps {
  item: FlowItemScorm;
}

const ScormCard: React.FC<ScormCardOwnProps> = ({ item }) => (
  <>
    <TopContent {...item} />
    <BottomContent cardLabel="SCORM" />
  </>
);

export default ScormCard;
